export function getBookingWindow(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = type => parts.find(p => p.type === type).value;
  const today = `${part('year')}-${part('month')}-${part('day')}`;
  const end = new Date(`${today}T00:00:00Z`);
  const dow = end.getUTCDay();
  end.setUTCDate(end.getUTCDate() + (dow === 0 ? 7 : 14 - dow));
  return { today, next_week_end: end.toISOString().slice(0, 10) };
}
